import React from 'react'
import {
  Header,
  Table,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import ScreenContainer from './ScreenContainer.js'
import Tier from './Tier.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemCounterCell from './OptionalItemCounterCell.js';
import OptionalCompareTableHeaderCells from './OptionalCompareTableHeaderCells.js'
import OptionalCompareItemCells from './OptionalCompareItemCells.js'
import { areas } from './curriculum.js'

const Area = ({ match, mode, selection, selections, comparisonMode, comparisonSelectionNames }) => {
  const area = areas.filter(area=>area.id===match.params.id)[0];
  const table = area.units.map(unit=>(
    <Table.Row key={unit.name}>
      <Table.Cell collapsing disabled>{unit.fqid}</Table.Cell>
      <Table.Cell><Link to={"/unit/"+unit.fqid}>{unit.name}</Link></Table.Cell>
      <Table.Cell collapsing textAlign='right'>{unit.core1}</Table.Cell>
      <Table.Cell collapsing textAlign='right'>{unit.core2}</Table.Cell>
      <Table.Cell collapsing textAlign='right'>{unit.electives?"Y":""}</Table.Cell>
      <OptionalItemCounterCell mode={mode} selection={selection} fqidPrefix={unit.fqid}/>
      <OptionalCompareItemCells mode={mode} selections={selections} comparisonMode={comparisonMode} comparisonSelectionNames={comparisonSelectionNames} fqidPrefix={unit.fqid}/>
    </Table.Row>
  ));
  return (
    <ScreenContainer mode={mode}>
      <Header as='h1'>
        <Header.Subheader>
          <Link to='/areas'>Areas</Link> / {area.name}
        </Header.Subheader>
        {area.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({area.id})</span>
      </Header>
      <Table compact='very' basic='very' selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing>
          </Table.HeaderCell>
          <Table.HeaderCell>
            Name
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Core-Tier1 <Tier tier='core1'/>
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Core-Tier2 <Tier tier='core2'/>
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Elective <Tier tier='elective'/>
          </Table.HeaderCell>
          <OptionalSelectTableHeaderCell mode={mode} selection={selection}/>
          <OptionalCompareTableHeaderCells
            mode={mode}
            selections={selections}
            comparisonMode={comparisonMode}
            comparisonSelectionNames={comparisonSelectionNames}
          />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        { table }
      </Table.Body>
    </Table>
    </ScreenContainer>
  )
}

export default Area